const validate = {
  rules: {
    titulo: {
      required: true,
    },
    descricao: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
    descricao: "A descrição é obrigatória.",
  },
};

export default validate;
